import { Component, Fragment, h, Prop } from '@stencil/core';
import { StepsError, Translations } from '../../../redux/types';
import { stepDoneSVG, stepCurrentSVG, stepDisabledSVG, stepErrorSVG } from './iconsSVG'
import { Unsubscribe } from "@stencil/redux";
import { store } from "../../../redux/store";
import { RootState } from "../../../redux/reducers";
import { stepKey, trans } from "../../../utils/trans";

@Component({
    tag: 'rentware-checkout-breadcrumbs',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareCheckoutBreadCrumbs {
    @Prop() steps;
    @Prop() visitedSteps: Array<string>;
    @Prop() currentStepIndex: number;
    @Prop() currentStep;
    @Prop() numberOfSteps: number;
    @Prop() onCloseBreadCrumbsClick;
    @Prop() onBreadCrumbsLinkClick;
    @Prop() isAnimationOpen;
    @Prop() errors: StepsError[];
    @Prop({ mutable: true }) translations: Translations;
    @Prop({ mutable: true }) locale: string;
    unsubscribe!: Unsubscribe;

    componentWillLoad() {
        this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
            return {
                translations: state.system.translations,
                locale: state.app.locale,
            };
        });
    }

    disconnectedCallback() {
        this.unsubscribe();
    }

    get breadCrumbsStyle() {
        return this.isAnimationOpen &&
            "BreadCrumbsContainer OpenBreadCrumbs" ||
            "BreadCrumbsContainer ClosedBreadCrumbs"
    }

    get modalStyle() {
        return this.isAnimationOpen &&
            "BreadCrumbsModal OpenModal" ||
            "BreadCrumbsModal ClosedModal";
    }

    get maxStep() {
        return this.visitedSteps.length;
    }

    mappedStep = (step, index) => {
        if (index !== 0) {
            const stepName = trans(stepKey(step.id), this.locale, this.translations);
            const itemClass = index === this.currentStepIndex && "StepItem CurrentItem" || "StepItem";
            const visitedClass = this.errors.some(error => error.stepId === step.id) && "Link Error" || "Link";
            const visitedOnClick = (index !== this.currentStepIndex) ? () => this.onBreadCrumbsLinkClick(step.id) : () => this.onCloseBreadCrumbsClick()

            const stepSVG = () => {
                if (index > this.maxStep) {
                    return (
                        <div class="IconContainer IconDisabled">
                            {stepDisabledSVG()}
                        </div>
                    );
                } else {
                    if (this.errors.some(error => error.stepId === step.id)) {
                        return (
                            <div class="IconContainer IconError">
                                {stepErrorSVG()}
                            </div>
                        );
                    } else {
                        if (index < this.maxStep) {
                            return (
                                <div class="IconContainer">
                                    {stepDoneSVG()}
                                </div>
                            );
                        } else {
                            return (
                                <div class="IconContainer">
                                    {stepCurrentSVG()}
                                </div>
                            );
                        }
                    }
                }
            }

            return (
                <Fragment>
                    {index > 1 &&
                        <div class="Line" />
                    }

                    <div class={itemClass}>
                        <div class="IconContainer">
                            {stepSVG()}
                        </div>

                        {this.visitedSteps.includes(step.id) &&
                            <span
                                class={visitedClass}
                                onClick={visitedOnClick}
                            >
                                {stepName}
                            </span>
                            ||
                            <span class="DisabledLink">
                                {stepName}
                            </span>
                        }
                    </div>
                </Fragment>
            )
        }
    }

    render() {
        return (
            <Fragment>
                <div class={this.breadCrumbsStyle}>
                    <div class="BreadCrumbsNav">
                        <div class="Left" />

                        <div
                            class="Center"
                        >
                            {trans('checkout.step', this.locale, this.translations)} {this.currentStepIndex}/{this.numberOfSteps}
                        </div>

                        <div class="Right">
                            <rentware-close-button
                                onClick={this.onCloseBreadCrumbsClick}
                            />
                        </div>

                    </div>

                    <div class="StepsContainer">
                        {this.steps.map(this.mappedStep)}
                    </div>

                    <rentware-spacer size="S" />
                </div>

                <div
                    class={this.modalStyle}
                    onClick={this.onCloseBreadCrumbsClick}
                />
            </Fragment >
        )
    }
}
